import { RetrievalMode } from '@prisma/client';

// The 7 renderings of a single BDM2 outcome. "pickup"/"mail" is how the physical
// 4g product is fulfilled - it never applies to the Galaxus voucher, which is never mailed
// or picked up; it is only ever credited to the participant's account and shown in the UI
// (the same is true for a cash top-up). The second half of the name is that voucher/cash
// payout shape: "NoCash" = a Galaxus voucher only (no cash), "Cash" = Galaxus + cash, and
// "FullProduct" = no residual at all, the whole 80 CHF went into the 4g product. See the
// Dok 3 v9 condition table this mirrors.
// Lives here, not next to resolveBdm2OutcomeVariant in the notification module, because the
// bdm-state DTO builds its enum from it and the waiting screen keys its copy off it - both
// outside rest.
export const BDM2_OUTCOME_VARIANTS = [
  'pickupNoCash',
  'pickupFullProduct',
  'pickupCash',
  'mailNoCash',
  'mailCash',
  'mailFullProduct',
  'noProduct',
] as const;

export type Bdm2OutcomeVariant = (typeof BDM2_OUTCOME_VARIANTS)[number];

/**
 * The fulfilment mode a variant was derived from. Reading it back off the variant lets a
 * caller that already holds the outcome skip a second lookup of the retrieval row - and
 * with it the window in which the two disagree. Kept in sync with
 * resolveBdm2OutcomeVariant by a round-trip test next to that function.
 */
export const RETRIEVAL_MODE_BY_BDM2_VARIANT: Record<
  Bdm2OutcomeVariant,
  RetrievalMode
> = {
  pickupNoCash: RetrievalMode.PICKUP,
  pickupFullProduct: RetrievalMode.PICKUP,
  pickupCash: RetrievalMode.PICKUP,
  mailNoCash: RetrievalMode.MAIL,
  mailCash: RetrievalMode.MAIL,
  mailFullProduct: RetrievalMode.MAIL,
  noProduct: RetrievalMode.NONE,
};
